/**
 * VoxPop menu component created by karora on 20/03/17.
 */
import { Component, OnInit } from '@angular/core';
import {AppComponent} from "../app.component";
import {ProfileService} from "../services/profile.service";

@Component({
  moduleId: module.id,
  selector: 'top-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})

export class MenuComponent implements OnInit {
  IsLoggedIn = ProfileService.IsLoggedIn;
  CanReview = ProfileService.CanReview;
  CanAdminister = ProfileService.CanAdminister;

  constructor() { }

  ngOnInit(): void {}


}
